import React from 'react';
import styled from 'styled-components';

interface CheckboxProps {
    indeterminate?: boolean;
    checked: boolean;
}

const CheckboxInput = styled.input`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;
`;

const CheckboxInner = styled.span<CheckboxProps>`
    position: relative;
    top: 0;
    left: 0;
    display: table;
    width: 16px;
    height: 16px;
    direction: ltr;
    border: 1px solid #d9d9d9;
    ${(props) =>
        props.checked
            ? `
		background-color: #577CE7;
		border-color: #577CE7;
	`
            : `background-color: #fff;
	`}
    border-radius: 2px;
    border-collapse: separate;
    transition: all 0.3s;

    ${(props) =>
        props.indeterminate
            ? `
		&:after {
			position: absolute;
			top: 50%;
			left: 50%;
			display: table;
			width: 8px;
			height: 8px;
			background-color: #577CE7;
			border: 0;
			transform: translate(-50%, -50%) scale(1);
			opacity: 1;
			content: " ";
		}`
            : props.checked
              ? `&:after {
				position: absolute;
				top: 50%;
				left: 21.5%;
				display: table;
				width: 5.71428571px;
				height: 9.14285714px;
				border: 2px solid #fff;
				border-top: 0;
				border-left: 0;
				transform: rotate(45deg) scale(1) translate(-50%, -50%);
				opacity: 1;
				content: " ";
			}`
              : `
		&:after {
			position: absolute;
			top: 50%;
			left: 21.5%;
			display: table;
			width: 5.71428571px;
			height: 9.14285714px;
			border: 2px solid #fff;
			border-top: 0;
			border-left: 0;
			transform: rotate(45deg) scale(0) translate(-50%, -50%);
			opacity: 0;
			transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
			content: " ";
		}
		`}
`;

const CheckboxWrapper = styled.label`
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    font-feature-settings: 'tnum';
    display: inline-flex;
    align-items: baseline;
    line-height: unset;
    cursor: pointer;
`;

interface CheckboxSpanProps {
    checked: boolean;
}

const CheckboxSpan = styled.span<CheckboxSpanProps>`
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    top: 0.2em;
    line-height: 1;
    white-space: nowrap;
    outline: none;
    cursor: pointer;
    display: flex;
    border-radius: 2px;
    ${(props) =>
        props.checked &&
        `background-color: #577CE7;
		border-color: #577CE7;`}

    &:after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid #577ce7;
        border-radius: 2px;
        visibility: hidden;
        animation: 0.36s ease-in-out;
        animation-fill-mode: backwards;
        content: '';
        ${(props) => !props.checked && `display: none;`}
    }
`;

export const Checkbox = ({
    name,
    checked,
    indeterminate,
    onChange,
}: {
    name?: string;
    checked: boolean;
    indeterminate?: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
}) => {
    return (
        <div style={{ display: 'flex' }} className='metui-checkbox'>
            {name && <span style={{ flex: 1 }}>{name}</span>}
            <CheckboxWrapper>
                <CheckboxSpan checked={checked}>
                    <CheckboxInput type='checkbox' name={name} checked={checked} onChange={onChange} />
                    <CheckboxInner checked={checked} indeterminate={indeterminate} />
                </CheckboxSpan>
            </CheckboxWrapper>
        </div>
    );
};
